"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _uuid = require("uuid");

var _core = require("@material-ui/core");

var _ = require("./..");

var _styles = _interopRequireDefault(require("./styles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var useStyles = (0, _core.makeStyles)(_styles.default, {
  name: 'ButtonIcon'
});

var ButtonIcon = function ButtonIcon(_ref) {
  var Icon = _ref.Icon,
      _ref$input = _ref.input,
      input = _ref$input === void 0 ? false : _ref$input,
      inputProps = _ref.inputProps,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["Icon", "input", "inputProps", "children"]);

  var classes = useStyles();
  var id = (0, _uuid.v4)();
  var label = input ? {
    component: 'label',
    htmlFor: id
  } : {};
  var inputElementProps = input ? {
    id: id
  } : {};
  return /*#__PURE__*/_react.default.createElement(_core.ButtonBase, _extends({
    className: classes.root
  }, label, rest), /*#__PURE__*/_react.default.createElement(Icon, {
    color: "secondary",
    className: classes.icon
  }), /*#__PURE__*/_react.default.createElement(_.Typography, {
    color: "secondary",
    className: classes.text
  }, children), input && /*#__PURE__*/_react.default.createElement("input", _extends({
    type: "file",
    className: classes.input
  }, inputElementProps, inputProps)));
};

ButtonIcon.propTypes = {
  Icon: _propTypes.default.any.isRequired,
  input: _propTypes.default.bool,
  inputProps: _propTypes.default.object,
  children: _propTypes.default.node
};
var _default = ButtonIcon;
exports.default = _default;